import { Form, Input, InputNumber } from "antd";
import { LabeledField } from "../../../../../common/components/labeledField/labeledField";

export default function UDFNumberInput({
  title = "Title",
  isFormItem = true,
  className,
  placeholder = "",
  formItemName = "",
  required = true,
  params,
  style = {},
  disabled = false,
  extraLabel = null,
}) {
  const renderField = () => (
    <InputNumber
      {...params}
      placeholder={placeholder}
      style={style}
      disabled={disabled}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        className={className}
        label={title}
        name={formItemName}
        initialValue={null}
        rules={required && [{ required: true, message: `Enter  ${title}` }]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label={title} required={required} extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
}
